import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_slice_ui } from '@/hooks/store/use_slices';
import i18n_page_diffusion_models from '@/locales/keys/i18n_page_diffusion_models.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { DTODiffusionModelUDBase } from '@shared/dto/+diffusion_model/+ud/_base/dto_diffusion_model_ud_base';
import { useTranslation } from 'react-i18next';
import { DiffusionModelsButtonRentAnimatedUD } from '../../tab_ud/buttons/diffusion_models_button_rent_animated_ud';

interface Props {
  diffusion_model: DTODiffusionModelUDBase;
}

export function DiffusionModelsButtonRentView({ diffusion_model }: Props) {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_DIFFUSION_MODELS);

  const { page_diffusion_models_table_row_hovered_id } = use_slice_ui(['page_diffusion_models_table_row_hovered_id']);
  /*
   * RENDERS
   */

  function render_view() {
    let out = <></>;

    let is_parent_hovered = diffusion_model._id === page_diffusion_models_table_row_hovered_id;

    const width = 140;
    const height = 40;

    if (diffusion_model.rent_price === 0) {
      return (
        <div style={{ height }} className="w-full flex items-center justify-start">
          <span className="overflow-hidden truncate whitespace-nowrap">{t(i18n_page_diffusion_models.button.rent.rent_free)}</span>
        </div>
      );
    }

    out = <DiffusionModelsButtonRentAnimatedUD className="!w-full !h-[40px]" {...{ diffusion_model, is_parent_hovered }} />;
    out = <div className=" flex justify-start items-center">{out}</div>;

    return out;
  }

  return (
    <UI_PRIMITIVE__tooltip
      delay_duration={50}
      tooltip_title={diffusion_model.rent_price === 0 ? t(i18n_page_diffusion_models.button.rent.rent_free) : ''}
      side="top"
    >
      {render_view()}
    </UI_PRIMITIVE__tooltip>
  );
}
